import { render, staticRenderFns } from "./GeneralCommentsView.vue?vue&type=template&id=281c5cc2&scoped=true&"
import script from "./GeneralCommentsView.vue?vue&type=script&lang=ts&"
export * from "./GeneralCommentsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281c5cc2",
  null
  
)

export default component.exports